import {
    $, _, addAction, INIT, LAYOUT,
} from '@situation/setdesign.util';

function initParallax() {
    const $images = $('.content-section > .content-background-image').find('.content-background-image__img');
    $('.initial-state').removeClass('initial-state');
    $('.accordion-panel').addClass('p-foreground').data('speed', 20);
    const $foreground = $('.p-foreground');
    let viewportHeight;
    if (!$images.length && !$foreground.length) {
        return;
    }

    function throttledScroll() {
        $images.each((i, el) => {
            const $this = $(el);
            const $parent = $this.parents('.content-background-image');
            const rect = $parent[0].getBoundingClientRect();
            let pos = rect.top / viewportHeight;
            pos = Math.round(pos * $this.data('distance') * -1);
            $this.css('transform', `translateY(${pos}px)`);
        });

        $foreground.each((i, el) => {
            const $this = $(el);
            const rect = el.getBoundingClientRect();
            let pos = viewportHeight - (rect.top + rect.height / 2);
            pos /= viewportHeight / 3;
            pos = Math.min(pos, 1);
            pos = Math.max(pos, 0);
            const opacity = Math.round(pos * 100) / 100;
            const speed = $this.data('speed') * (1 - pos);
            $this.css({ opacity, transform: `translateY(${Math.round(speed * (1 - pos))}px)` });
        });
    }

    const onScroll = _.throttle(throttledScroll, 10, { leading: true });

    const measureItems = () => {
        viewportHeight = SetDesign.viewport.height();
        $images.each((i, el) => {
            const $this = $(el);
            const $parent = $this.parents('.content-background-image');
            const height = $this.outerHeight();
            const parentHeight = $parent.outerHeight();
            $this.data('distance', height - parentHeight);
        });

        $foreground.each((i, el) => {
            const $el = $(el);
            if ($el.data('speed')) return;

            const match = el.className.match(/p-foreground--(\d+)/);
            const speed = match?.[1] ?? 50;
            $el.data('speed', Number(speed));
        });

        onScroll();
    };

    measureItems();
    addAction(LAYOUT, measureItems);
    $(window).on('scroll', onScroll);
}

addAction(INIT, initParallax, 20);
